import React from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { removeAccents } from '../../../components/utils/ParseUtils';
import I18n from 'i18n-react';

import './TextField.css';

const propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  isUpperCase: PropTypes.bool,
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  changeValue: PropTypes.func.isRequired,
  trim: PropTypes.bool,
  value: PropTypes.string
};

const defaultProps = {
  label: '',
  required: false,
  isUpperCase: false,
  errorMessage: '',
  placeholder: '',
  maxLength: 999,
  trim: false,
  value: null
};

class TextFieldPassport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValidState: true,
      value: props.value ? props.value : ''
    };
  }

  componentWillReceiveProps(props) {
    if (props.value !== null) {
      this.setState({
        value: props.value
      });
    }
  }

  renderLabel() {
    let label = '';

    if (this.props.label) {
      label = (
        <Row className="Field__label">
          <Col id={`${this.props.id}_textFieldLabel`} xs={12}>
            <span className={this.state.isValidState ? 'Field__validField' : 'Field__invalidField'}>
              {I18n.translate(this.props.label)}
            </span>
            {this.props.required ? (
              <span id="requiredIconId" className="Field__required">
                {' '}
                •
              </span>
            ) : (
              ''
            )}
          </Col>
        </Row>
      );
    }

    return label;
  }

  renderField() {
    return (
      <Row>
        <Col xs={12}>
          <input
            type="text"
            id={`${this.props.id}_textFieldId`}
            onBlur={event => this.validateField(event.target.value)}
            onChange={event => this.changeValue(event.target.value)}
            placeholder={I18n.translate(this.props.placeholder)}
            maxLength={this.props.maxLength}
            className={`data-hj-whitelist Field__input ${this.state.isValidState ? 'Field__validInput' : 'Field__invalidInput'
              }`}
            value={this.state.value}
            ref={ref => (this.input = ref)}
          />
        </Col>
      </Row>
    );
  }

  renderValidationMessage() {
    let message = <Row id={`${this.props.id}_textFieldFooter`} className="Field__message" />;

    if (!this.state.isValidState) {
      message = (
        <Row className="Field__message error">
          <Col id={`${this.props.id}_textFieldFooter`} xs={12}>
            <span className="Field__invalidField">{I18n.translate(this.props.errorMessage)}</span>
          </Col>
        </Row>
      );
    }

    return message;
  }

  validate = () => {
    return this.validateField(this.state.value);
  };

  validateField(value) {
    const isValid = !this.props.required || (this.props.required && value.length > 0);

    this.setState({
      isValidState: isValid,
      value: value
    });
    this.props.changeValue(value);

    return isValid;
  }

  changeValue(value) {
    this.setState({
      value: value
    });
  }

  render() {
    return (
      <div id={this.props.id} className="TextField Field">
        {this.renderLabel()}
        {this.renderField()}
        {this.renderValidationMessage()}
      </div>
    );
  }
}

TextFieldPassport.propTypes = propTypes;
TextFieldPassport.defaultProps = defaultProps;

export default TextFieldPassport;



// WEBPACK FOOTER //
// ./src/components/passengerInfo/textField/TextFieldPassport.jsx